import { createModal } from '/@/core/elements/modal'
import { type ThingType } from '/@/common/things/types'

interface SubmitToFeedModalData {
  type: ThingType | null
}

const { api, component } = createModal<SubmitToFeedModalData>(
  'SubmitToFeedModal',
  () => import('./SubmitToFeedModal.vue'),
  {
    type: null,
  },
)

export const useSubmitToFeedModal = api
export default component
